import * as React from 'react';
import PriceDisplay from '../../../../../../components/Others/PriceDisplay';

export interface IPriceRowProps {
  weightRange: string;
  prices: GQL.IDeliveryMethodPrice[];
  currency?: GQL.ICurrency;
  onClick?: Function;
}

export default class PriceRow extends React.Component<IPriceRowProps> {

  public render() {
    const { weightRange, prices, currency } = this.props;

    // z pole cen musím najít záznam s primární cenou
    const price = prices.find((price: GQL.IDeliveryMethodPrice) => {
      if (
        `${price.fromWeight}-${price.toWeight}` === weightRange
          && ((currency && price.currencyId === currency.id)
            || (!currency && price.priceWithout)
            || !price.currencyId)
      ) {
        return true;
      }
      return false;
    });

    if (!price) {
      return null;
    }

    return (
      <div
        onClick={(e: any) => {
          if (this.props.onClick) {
            this.props.onClick(e);
          }
        }}
        style={{
          cursor: this.props.onClick ? 'pointer' : '',
          width: '100%',
        }}
      >
        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'flex-start',
            alignItems: 'center',
          }}
        >
          <div style={{ display: 'flex', alignItems: 'flex-start', flexDirection: 'column', width: '60%' }}>
            {`${this.definitionWeightRange(price)}`}
          </div>
          <div style={{ display: 'flex', alignItems: 'flex-end', flexDirection: 'column', width: '40%' }}>
            {!price.active || price.active === true
              ? price.priceWithout !== null && price.priceWithout >= 0
                ? <PriceDisplay amount={price.priceWithout} currency={currency} />
                : '-'
              : 'disabled'}
          </div>
        </div>
      </div>
    );
  }

  private definitionWeightRange(price: GQL.IDeliveryMethodPrice) {
    let result = '';
    if (price && price.fromWeight && price.fromWeight > 0) {
      result = `min ${price.fromWeight} kg`;
    }
    if (price && price.toWeight && price.toWeight > 0) {
      if (result !== '') {
        result += `, `;
      }
      result += `max ${price.toWeight} kg`;
    }
    if (result === '') {
      return 'any weight';
    }
    return result;
  }
}



// WEBPACK FOOTER //
// ./src/scenes/DeliveryMethods/DeliveryMethodDetail/components/PricesByWeight/components/PriceRow.tsx